import { Injectable } from '@angular/core';
import { Platform } from '@app/classes';
import { MenuItem } from '@app/interfaces';
import { MenuService } from '@app/services/menu/menu.service';

const JobPostingMenu: MenuItem[] = [
    {
        key: 'applicant-tracker.applicants.title',
        link: ['/recruiting', 'jobPostings', ':jobPosting', 'applicants'],
    },
    {
        key: 'applicant-tracker.funnel',
        link: ['/recruiting', 'jobPostings', ':jobPosting', 'pipeline'],
    },
    {
        key: 'applicant-tracker.information',
        link: ['/recruiting', 'jobPostings', ':jobPosting', 'information'],
    },
    {
        key: 'applicant-tracker.interviews',
        link: ['/recruiting', 'jobPostings', ':jobPosting', 'interviews'],
    },
    {
        key: 'applicant-tracker.reports',
        link: ['/recruiting', 'jobPostings', ':jobPosting', 'reports'],
        can: [Platform.recruiting.permission.recruiter],
    },
    {
        key: 'applicant-tracker.settings',
        link: ['/recruiting', 'jobPostings', ':jobPosting', 'settings'],
        can: [Platform.recruiting.permission.recruiter],
    },
];

@Injectable()
export class JobPostingMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = JobPostingMenu;
    }
}
